import { render, staticRenderFns } from "./r-tutorial-dialog.vue?vue&type=template&id=40c7a526&scoped=true"
import script from "./r-tutorial-dialog.vue?vue&type=script&lang=js"
export * from "./r-tutorial-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-tutorial-dialog.vue?vue&type=style&index=0&id=40c7a526&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7a526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c7a526')) {
      api.createRecord('40c7a526', component.options)
    } else {
      api.reload('40c7a526', component.options)
    }
    module.hot.accept("./r-tutorial-dialog.vue?vue&type=template&id=40c7a526&scoped=true", function () {
      api.rerender('40c7a526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/tutorial/r-tutorial-dialog.vue"
export default component.exports